'use client';

import type { UriType } from '~/model/GlobalTypes';
import { VpButton } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { keyboardKeys } from '~/const/keyCodes';
import { useBreakpoint } from '~/hooks/match-media/useBreakpoint';
import { StarRatingInput } from './Rating/StarRatingInput';
import { TranslationRatingWrapper } from './TranslationRatingWrapper';

export const TranslationRating = ({ entityUri }: { entityUri: UriType }) => {
  const t = useTranslations('GLOBAL.TRANSLATION_RATING');

  const [isRatingOpen, setIsRatingOpen] = useState(false);
  const { isSBreakpoint } = useBreakpoint();

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === keyboardKeys.ESCAPE)
      setIsRatingOpen(false);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  return (
    <div className="translate__rating" data-testid="translation-rating">
      <VpButton
        className="translate__action"
        onClick={() => setIsRatingOpen(!isRatingOpen)}
        variant="tertiary"
      >
        {t('LABEL')}
      </VpButton>
      {isRatingOpen && (
        <TranslationRatingWrapper
          isSBreakpoint={isSBreakpoint}
          isRatingOpen={isRatingOpen}
          setIsRatingOpen={setIsRatingOpen}
        >
          <StarRatingInput
            isSBreakpoint={isSBreakpoint}
            entityUri={entityUri}
            setIsRatingOpen={setIsRatingOpen}
          />
        </TranslationRatingWrapper>
      )}
    </div>
  );
};
